import angular from 'angular';

import OptionSelectComponent from './option-select.cmpt';

export default angular
    .module('application.component.option-select', [])
    .component(OptionSelectComponent.selector, OptionSelectComponent);



// WEBPACK FOOTER //
// ./src/application/component/option-select/index.js